import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./profilepanel.scss";
import User from "./user";
import Menus from "./menus";
import Close from "./assets/icons/close.png";
import {
  getRouter,
  getUserLandingPage,
} from "@tw/shared-ui-components/lib/utils/helper";
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";
import { getQueryUTMString } from '@tw/shared-ui-components/lib/utils/helper';
const ProfilePanel = (props) => {
  const { showMenu, callback, callFromHeader, Link, breakpoint } = props;
  // callback is for 'callFromHeader' -- referring to <Header>
  const [showPanel, setShowPanel] = useState(showMenu);
  const loginState = useSelector((state) => state.loginState);
  const cookie = new Cookies();
  const curAda = cookie.get("ada");
  let isDesktop = breakpoint !== "xs" && breakpoint !== "sm";
  const router = getRouter();

  let login = { ada: "", role: "Guest", user: [] };
  //login = { ada: '6666666', role: 'TC', user: [{"name":"Test","amwayId":"1300000200761001", "isMaster":true,"isBindPhone":true,"isBindLine":false, userTicket:"c02cb57c85fe4e2e9c97a5bba4517ef7"}]};

  if (loginState !== undefined && loginState.login) {
    login = {
      ada: loginState.login.ada || "",
      role: loginState.login.role || "Guest",
      user: loginState.login.user || [],
      distributorType: loginState.login.loginType || "",
      isGuest: (typeof loginState.login.isGuest == "boolean") ? loginState.login.isGuest :
        (loginState.login.isGuest === "true") ? true : false,
    };
  }
  //console.log(login, showPanel?'show':'hide', isDesktop ? 'desktop' : 'mobile', getUserLandingPage())

  if (typeof window !== "undefined" && showPanel) {
    if (
      callFromHeader &&
      isDesktop &&
      login.role !== "Guest" &&
      login.ada !== ""
    )
      // valid login
      router.push(`${getUserLandingPage()}${getQueryUTMString("?")}`); // to customer identity
  }

  const closeMenu = () => {
    if (!isDesktop) {
      callback(false);
      setShowPanel(false);
    }
  };

  return (
    <div className={`${styles.menuPanel} ${!isDesktop ? styles.mobile : ""}`}>
      {!isDesktop && (
        <div className={styles.mobileClose}>
          <span onClick={closeMenu}>
            <img src={Close} />
          </span>
        </div>
      )}
      {curAda && curAda !== "" && (
        <div style={{ padding: isDesktop ? "0" : "0 16px" }}>
          <User Link={Link} login={login} toggleCloseMenu={closeMenu} />
          <div className={styles.divider}></div>
        </div>
      )}
      {
        <Menus
          toggleCloseMenu={closeMenu}
          Link={Link}
          role={login.role}
          curAda={curAda}
          breakpoint={breakpoint}
        />
      }
    </div>
  );
};

ProfilePanel.defaultProps = {
  showMenu: true,
  callback: (v) => {
    console.log("default func " + v);
  },
  callFromHeader: false,
};

ProfilePanel.propTypes = {
  showMenu: PropTypes.bool,
  callback: PropTypes.func,
  callFromHeader: PropTypes.bool,
};

export default ProfilePanel;
